import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { validate as isValidUUID } from 'uuid';

const validateUUIDv4 = uuid => {
  return isValidUUID(uuid);
};

const PasswordCreateResetRoute = ({
  component: Component,
  authenticated,
  path,
}) => {
  const query = useSelector(state => state.router?.location.query);
  const allTrue = query && validateUUIDv4(query.u) && path === '/pwd-create';

  const RenderRoute = (props, auth) => {
    if (auth) {
      return <Component {...props} />;
    } else if (allTrue) {
      return <Component {...props} />;
    }
    return null;
  };

  // eslint-disable-next-line new-cap
  return <Route render={props => RenderRoute(props, authenticated)} />;
};

PasswordCreateResetRoute.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  component: PropTypes.object.isRequired,
  location: PropTypes.string,
  path: PropTypes.string,
};

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
});

export default connect(mapStateToProps)(PasswordCreateResetRoute);
